import React, { useState } from 'react';
import jwt from 'jsonwebtoken';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Pagination,
  PaginationItem,
  PaginationLink
} from 'reactstrap';
import classnames from 'classnames';

const MAX_REPORTS = 5;

const reportConfigs = [
  { url: "http://122.255.48.190:6005", name: 'Sales Overview', secret: '17930efa0d4a48b41f888a69d28a3bb6737178ca07e837b73b6330441127d58d', questionId: 1934 },
  { url: "http://122.255.48.190:6005", name: 'Inventory Status', secret: 'e13e0aa29...', questionId: 1935 },
  { url: "http://122.255.48.190:6005", name: 'Customer Trends', secret: '9b81239fa...', questionId: 1936 },
  { url: "http://122.255.48.190:6005", name: 'Top Products', secret: '8b90239fa...', questionId: 1937 },
  { url: "http://122.255.48.190:6005", name: 'Store Analysis', secret: '7a70239fa...', questionId: 1938 },
  { url: "http://122.255.48.190:6005", name: 'Too Much Report', secret: '6b60239fa...', questionId: 1939 },
  { url: "http://122.255.48.190:6005", name: 'Marketing Overview', secret: 'a123...', questionId: 1940 },
  { url: "http://122.255.48.190:6005", name: 'HR Trends', secret: 'b123...', questionId: 1941 }
];

const generateIframeUrl = (url, secret, questionId) => {
  const payload = {
    resource: { question: questionId },
    params: {},
    exp: Math.round(Date.now() / 1000) + (10 * 60)
  };
  const token = jwt.sign(payload, secret);
  return `${url}/embed/question/${token}#bordered=true&titled=true`;
};

const MetabaseTabViewer = ({ reportList }) => {
  const [openReports, setOpenReports] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [warning, setWarning] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const reportsPerPage = 6;

  const indexOfLastReport = currentPage * reportsPerPage;
  const indexOfFirstReport = indexOfLastReport - reportsPerPage;
  const currentReports = reportList.slice(indexOfFirstReport, indexOfLastReport);
  const totalPages = Math.ceil(reportList.length / reportsPerPage);

  const handleOpenReport = (report) => {
    setWarning('');
    const alreadyOpen = openReports.find((r) => r.name === report.name);
    if (alreadyOpen) {
      setActiveTab(report.name);
      return;
    }

    if (openReports.length >= MAX_REPORTS) {
      setWarning(`You can only open up to ${MAX_REPORTS} reports at once due to memory constraints.`);
      return;
    }

    const iframeUrl = generateIframeUrl(report.url, report.secret, report.questionId);
    const newReport = { ...report, iframeUrl };
    setOpenReports((prev) => [...prev, newReport]);
    setActiveTab(report.name);
  };

  const handleCloseTab = (name) => {
    setOpenReports((prev) => prev.filter((r) => r.name !== name));
    if (activeTab === name) {
      setActiveTab(null);
    }
  };

  const handleRefresh = (report) => {
    const refreshedUrl = generateIframeUrl(report.secret, report.questionId);
    setOpenReports((prev) =>
      prev.map((r) => (r.name === report.name ? { ...r, iframeUrl: refreshedUrl } : r))
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Container fluid className="my-4 px-4">
      <h3 className="mb-4">Available Reports</h3>

      {warning && (
        <Alert color="danger">
          ⚠️ {warning}
        </Alert>
      )}

      <Row className="mb-4">
        {currentReports.map((report) => (
          <Col md="4" lg="3" className="mb-4" key={report.name}>
            <Card
              style={{
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease-in-out',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.05)'}
            >
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h5" className="mb-0">{report.name}</CardTitle>
                  <Button color="primary mx-2" onClick={() => handleOpenReport(report)} size="sm">
                    View Report
                  </Button>
                </div>
              </CardBody>


            </Card>
          </Col>
        ))}
      </Row>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <Pagination className="justify-content-center mb-4" size='sm'>
          {[...Array(totalPages)].map((_, i) => (
            <PaginationItem key={i} active={i + 1 === currentPage}>
              <PaginationLink onClick={() => handlePageChange(i + 1)}>
                {i + 1}
              </PaginationLink>
            </PaginationItem>
          ))}
        </Pagination>
      )}

      {/* Open Reports */}
      {openReports.length > 0 && (
        <>
          <h4 className="mb-3">Open Reports</h4>
          <Nav tabs className="mb-3">
            {openReports.map((report) => (
              <NavItem key={report.name}>
                <NavLink
                  className={classnames({ active: activeTab === report.name })}
                  onClick={() => setActiveTab(report.name)}
                  style={{ cursor: 'pointer' }}
                >
                  {report.name}
                  <Button size="sm" color="link" onClick={(e) => { e.stopPropagation(); handleRefresh(report); }} title="Refresh">🔄</Button>
                  <Button size="sm" color="link" onClick={(e) => { e.stopPropagation(); handleCloseTab(report.name); }} title="Close">×</Button>
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          <TabContent activeTab={activeTab}>
            {openReports.map((report) => (
              <TabPane tabId={report.name} key={report.name}>
                {report.iframeUrl ? (
                  <iframe
                    src={report.iframeUrl}
                    title={report.name}
                    frameBorder="0"
                    width="100%"
                    height="800"
                    allowTransparency
                  />
                ) : (
                  <div className="text-center text-muted p-4">
                    Report is unloaded. Click 🔄 to reload.
                  </div>
                )}
              </TabPane>
            ))}
          </TabContent>
        </>
      )}
    </Container>
  );
};

export default MetabaseTabViewer;
